import expertKredytowyLogo from "@/assets/expert-kredytowy-logo-960.webp";
import expertKredytowyLogoStandard from "@/assets/expert-kredytowy-logo-640.webp";

export default function Logo({ size = "md", onClick }: { size?: "sm" | "md" | "lg"; onClick?: () => void }) {

  const logoWidth = size === "sm" ? "w-[142px] sm:w-[156px]" : size === "md" ? "w-[178px] sm:w-[212px]" : "w-[230px] sm:w-[280px]";

  return (
    <a
      href="/"
      onClick={onClick}
      className="flex items-center cursor-pointer"
      aria-label="EXPERT KREDYTOWY – Strona główna"
    >
      <img
        src={expertKredytowyLogo}
        srcSet={`${expertKredytowyLogoStandard} 640w, ${expertKredytowyLogo} 960w`}
        sizes={size === "sm" ? "(min-width: 640px) 156px, 142px" : size === "md" ? "(min-width: 640px) 212px, 178px" : "(min-width: 640px) 280px, 230px"}
        alt="EXPERT KREDYTOWY"
        decoding="async"
        className={`${logoWidth} h-auto max-h-12 sm:max-h-14 object-contain object-left`}
      />
    </a>
  );
}
